import { render, staticRenderFns } from "./misFacturas.vue?vue&type=template&id=5bfe3b50&scoped=true&"
import script from "./misFacturas.vue?vue&type=script&lang=js&"
export * from "./misFacturas.vue?vue&type=script&lang=js&"
import style0 from "./misFacturas.vue?vue&type=style&index=0&id=5bfe3b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe3b50",
  null
  
)

export default component.exports